import { Pipe, PipeTransform } from '@angular/core';
import { MapItem } from '@capturum/ui/api';

@Pipe({
  name: 'findLabelByValue',
})
export class FindLabelByValuePipe implements PipeTransform {
  public transform(value: string, values: (MapItem & { items: MapItem[] })[], identifier: string = 'value'): string {
    let result: MapItem;

    values.forEach((item) => {
      if (!result && item[identifier] === value) {
        result = item;
      } else if (!result && item.items) {
        result = item.items.find((childItem) => childItem[identifier] === value);
      }
    });

    return result?.label ?? null;
  }
}
